export default "__VITE_ASSET__2bC$vV8Y__"